// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"1b3f0ab4","217":"c13e852c","453":"5fe83a51","455":"1daabf88","631":"c6c7b61e","813":"6e02e687","835":"b6014328","931":"837af106","935":"d6a0dbdc","977":"3c7f9716","984":"814edfff","991":"deba5d87"}[chunkId] + ".chunk.js";
};